import {
  IconBookmark,
  IconChartLine,
  IconFlag,
  IconGitCompare,
  IconMap,
  IconShield,
  IconStar,
  IconTrendingUp,
  IconWorld,
} from "@tabler/icons-react";

export const sections = [
  {
    id: "bookmarks",
    title: "Bookmarks",
    icon: IconBookmark,
  },
  {
    id: "trending-topics",
    title: "Trending Topics",
    icon: IconTrendingUp,
  },
  {
    id: "by-country",
    title: "By Country",
    icon: IconWorld,
  },
  {
    id: "eu-priorities",
    title: "EU Priorities",
    icon: IconFlag,
  },
  {
    id: "recommended",
    title: "Recommended",
    icon: IconStar,
  },
  {
    id: "trusted-sources",
    title: "Trusted Sources",
    icon: IconShield,
  },
  {
    id: "comparisons",
    title: "Comparisons",
    icon: IconGitCompare,
  },
  {
    id: "on-the-map",
    title: "On the Map",
    icon: IconMap,
  },
  {
    id: "time-series",
    title: "Time Series",
    icon: IconChartLine,
  },
];
